import { AxiosError } from 'axios';
import {
  DefaultApi,
  ReportPublishJobResponse,
} from '@ansvar-sakerhet/api-client';

const POLL_INTERVAL_MS = 2000;
const TIMEOUT_MS = 5 * 60 * 1000;

const TERMINAL_STATUSES = new Set(['completed', 'failed']);

const sleep = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });

type ConflictBody = {
  message?: string;
  reportPublishJobId?: string;
};

type ApiClient = Pick<
  DefaultApi,
  'controlsPublishReport' | 'controlsFindPublishReportJob'
>;

export async function runPublishReportJob(
  getApi: () => Promise<ApiClient>,
  controlId: string,
  noId06: boolean,
  onJobUpdate: (job: ReportPublishJobResponse) => void
): Promise<ReportPublishJobResponse> {
  const api = await getApi();
  const startedAt = Date.now();

  let job: ReportPublishJobResponse;

  try {
    const response = await api.controlsPublishReport(controlId, noId06);
    job = response.data;
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 409) {
      const body = error.response.data as ConflictBody;

      if (body.reportPublishJobId) {
        const existing = await api.controlsFindPublishReportJob(
          controlId,
          body.reportPublishJobId
        );
        job = existing.data;
      } else {
        throw error;
      }
    } else {
      throw error;
    }
  }

  onJobUpdate(job);

  while (!TERMINAL_STATUSES.has(job.status)) {
    if (Date.now() - startedAt > TIMEOUT_MS) {
      throw new Error('Publiceringen tog för lång tid. Försök igen.');
    }

    await sleep(POLL_INTERVAL_MS);

    const response = await api.controlsFindPublishReportJob(
      controlId,
      job.reportPublishJobId
    );
    job = response.data;
    onJobUpdate(job);
  }

  return job;
}
